import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, uniqueToken } from '../../api/DataApis';
import { Link, useParams } from 'react-router-dom';
import Loader from './Loader';  
import ReactPaginate from 'react-paginate'; 
import "./Charger.css"
import request from '../../Apis/request';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';




const Chargers = () => {
  document.title = "Chargers";

  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [ChargerData, setChargerData] = useState([]);
  const [chargingList, setChargingList] = useState([]);
  const [selectedchargerType, setselectedchargerType] = useState([]);
  const [filteredChargerData, setFilteredChargerData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1); 
  const [pageCount, setPageCount] = useState(0); 
  const [userStatuses, setUserStatuses] = useState({});
  const [statusListing, setStatusListing] = useState([]);
  const [Limit, setLimit] = useState({});
  const [TotalCount, setTotalCount] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [importFileData, setImportFileData] = useState(null);
  const [selectconnectorCount, setselectedconnectorCount] = useState('');

  let navigate = useNavigate();

  const handleReset = (event) => {
    event.preventDefault()
   navigate(`/chargers`);
    }


  let params = useParams();
let stationnID = params?.nid;
console.log("stationnID", stationnID);


const fileInputRef = useRef(null);

const ImportData = () => {
  fileInputRef.current.click(); 
}

const handleFileChange = async (event) => {
  const file = event.target.files[0];
  console.log('Selected file:', file);
  setImportFileData(file); // Store the file in state

  if (file) {
    const formData = new FormData();
    formData.append('file', file); // 'file' should match the backend field name

    try {
      const confirmation = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to upload this file?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, upload it!',
        cancelButtonText: 'No, cancel!',
      });

      if (confirmation.isConfirmed) {
        const response = await fetch(`${BaseURL}/chargers/import-excel`, {
          method: 'PUT',
          body: formData,
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
            // 'Content-Type' is automatically set when using FormData
          },
        });

        const data = await response.json();
        if (response.status === 200) {
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: data.message,
          });
        }
      } else {
        Swal.fire({
          icon: 'info',
          title: 'Cancelled',
          text: 'Your file upload has been cancelled.',
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error('Error during file upload:', error);
      Swal.fire({
        icon: 'error',
        title: 'Upload Failed',
        text: 'An error occurred during file upload. Please try again later.',
      });
    }
  }
};


  const handleStatus = (e) => {
    setSelectedStatus(e.target.value);
  }
  

const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
  };

  const handlechargerType = (e) => {
    setselectedchargerType(e.target.value);
}

const handleconnectorCount = (e) => {
  setselectedconnectorCount(e.target.value);
}

  const handleSearchSubmit = (e) => {
    e.preventDefault();  // Prevent default form submission
    setPage(1);  // Reset to the first page
    fetchChargers(1, searchTerm);  // Trigger the API call with search term on form submit
  };

  const fetchChargers = async (currentPage) => {
    setLoadings(true);

    // Set the base API endpoint
    let apiEndpoint = `${BaseURL}/chargers/?page=${page}&searchText=${searchTerm}&master_charger_type_id=${selectedchargerType}&status=${selectedStatus}&connectorCount=${selectconnectorCount}`;

    // Conditionally add station_id to the endpoint if stationnID exists
    if (stationnID) {
        apiEndpoint += `&station_id=${stationnID}`;
    }

    try {
        const response = await axios.get(apiEndpoint, {
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: `Bearer ${uniqueToken}`,
            },
        });

        setChargerData(response.data.data.data || []);
        setFilteredChargerData(response.data.data.data || []); 

        setPageCount(Math.ceil(response.data.data?.totalCount / response.data.data?.limit || 0));
        setLimit(response.data.data?.limit);
        setTotalCount(response.data.data?.totalCount);
    } catch (error) {
        console.error("Error fetching ChargerData:", error);
    } finally {
        setLoadings(false);
    }
};

useEffect(() => {
  fetchChargers(page);  // Fetch chargers based on the current page and search term
}, [page]);

  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1;
    setPage(selectedPage);
  };
  const handleStatusType = async (event, userId) => {
    const status = event.target.value;
  
    // Update local state
    setUserStatuses(prevStatuses => ({
      ...prevStatuses,
      [userId]: status
    }));
  
    const url = `${BaseURL}/chargers/changestatus/${userId}`;
  
    // Create JSON payload
    const statusData = { status };
  
    try {
      // Send status as JSON instead of FormData
      const response = await axios.put(url, statusData, {
        headers: {
          "Content-Type": "application/json", // Send as JSON
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
  
      // Handle the response
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response.data.message, 
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        console.log("Failed to update status", response.data);
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };
  const fetchStatusListing = async () => {
    const apiEndpoint = `${BaseURL}/settings/charger/status`;

    setLoading(true);

    var url = apiEndpoint

    let res = await request({
      url: url,
      method: "GET",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${uniqueToken}`,
      },
    });

    console.log("res", res);
   
    if (res && res.data) {
      setStatusListing(res.data);
      }

    return [];
  };

  useEffect(() => {
    fetchStatusListing();
  }, []);
  
  useEffect(() => {
    const ChargingTypesData = async () => {
      setLoading(true);
      const apiEndpoint = `${BaseURL}/master/station_charger-0`;
      try {
        const response = await axios.get(apiEndpoint, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        console.log("ocpps response", response);
        setChargingList(response?.data?.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      } finally {
        setLoading(false);
      }
    };
     ChargingTypesData();
  }, []);
  
console.log("charginglist", chargingList);
console.log("pageCount", pageCount);
console.log("limit", Limit);
console.log("chargerData", ChargerData);
  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>

            <div className="portlet-body mx-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
  {/* Chargers heading and Total Chargers button */}
  <div className="d-flex align-items-center">
    <h4 style={{ marginRight: "10px" }}>Chargers({TotalCount ? TotalCount : "Loading..." })</h4>  {/* Add margin to separate */}
   
  </div>

  {/* Add Chargers button */}

</div>

              <hr style={{ marginTop: "5px" }} />
              <div className="row" style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "nowrap" }}>
  <div className="col-md-2" style={{ flex: "1" }}>
    <input
      type="text"
      placeholder="Find Data Here."
      onChange={handleSearchChange}
      value={searchTerm}
      className="form-control"
      style={{ height: "38px", boxSizing: "border-box" }}
    />
  </div>
  
  <div className="col-md-2" style={{ flex: "1" }}>
    <select
      onChange={handlechargerType}
      className="form-control"
      style={{ height: "38px", boxSizing: "border-box" }}
    >
      <option>Select Charger Type</option>
      {chargingList?.map((item) => (
        <option key={item?._id} value={item?._id}>
          {item?.title}
        </option>
      ))}
    </select>
  </div>
  
  <div className="col-md-2" style={{ flex: "1" }}>
    <select
      className="form-control"
      style={{ height: "38px", boxSizing: "border-box" }}
      onChange={handleStatus}
    >
      <option value="">Select Status</option>
      <option value="Active">Active</option>
      <option value="InActive">InActive</option>
      <option value="Deleted">Deleted</option>
    </select>
  </div>

  <div className="col-md-2" style={{ flex: "1" }}>
    <input
      type="number"
      placeholder="Conn.. Count"
      className="form-control"
      style={{ height: "38px", boxSizing: "border-box" }}
      onChange={handleconnectorCount}
    />
  </div>
  
  <div className="col-md-2" style={{ flex: "1", display: "flex", justifyContent: "center" }}>
    <button 
      type="submit" 
      className="btn btn-primary" 
      style={{ height: "38px", width: "100%", lineHeight: "1" }}
      onClick={handleSearchSubmit}
    >
      Search
    </button>

  </div>
  <div className="col-md-2" style={{ flex: "1", display: "flex", justifyContent: "center" }}>

  <button
    className="btn btn-primary"
    onClick={handleReset} // Calls the handleReset function
    style={{
      marginLeft: "30px", // Space between the buttons
      height: "38px", // Consistent height
      width: "100px", // Slightly smaller width for Reset button
      display: "flex", // Enable flexbox for centering
      justifyContent: "center", // Center horizontally
      alignItems: "center", // Center vertically
      padding: 0, // Ensure no extra padding that could offset centering
    }}
  >
    Reset
  </button>
  </div>

  <div className="col-md-2" style={{ flex: "1", display: "flex", justifyContent: "center" }}>
    <button
      className="btn btn-primary"
      style={{
        height: "38px",
        width: "90%",
        fontWeight: "bold",
        fontSize: "14px",
        cursor: "pointer",
        transition: "background 0.3s, transform 0.2s",
      }}
      onClick={ImportData}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = "#218838";
        e.target.style.transform = "scale(1.05)";
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = "";
        e.target.style.transform = "scale(1)";
      }}
    >
      Import
    </button>
    <input
      type="file"
      ref={fileInputRef}
      style={{ display: 'none' }}
      onChange={handleFileChange}
    />
  </div>
</div>



              <div className="card-body" style={{ marginLeft: "-19px" }}>
                {loadings ? (
                  <Loader /> 
                ) : (
                  <>
                    <div className="table-responsive">
                      
                    <table className="display dataTable" id="advance-1">
  <thead>
    <tr>
      <th>Sr. No</th>
      <th>Charger Name</th>
      <th>Installation Date</th>
      <th>Connector Count</th>
      <th>Station Name</th>
      <th>IMEI Number</th>
      <th>Status</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    {filteredChargerData?.length === 0 ? (
      <tr>
        <td colSpan="8" className="text-center">No Data Available</td>
      </tr>
    ) : (
      filteredChargerData?.map((charger, index) => (
        <tr key={index}>
          <td style={{ whiteSpace: 'nowrap' }}>{(page - 1) * Limit + index + 1}</td>
       
          <td>{charger?.charger_name}</td>
          <td style={{ whiteSpace: 'nowrap' }}>{charger?.createdAt}</td>
          <td style={{ whiteSpace: 'nowrap', alignItems: "center" }}>{charger?.connectorCount}</td>
          <td>{charger?.station_name}</td>
          <td style={{ whiteSpace: 'nowrap' }}>{charger?.imei_number}</td>
          <td style={{ whiteSpace: 'nowrap' }}>
            <select
              onChange={(e) => handleStatusType(e, charger?._id)}
              value={userStatuses[charger._id] || charger.status} 
              className="custom-select"
              id="statusType"
              name="statusType"
            >
              {statusListing ? (
                statusListing?.map((statusObj, index) => {
                  const statusKey = Object.keys(statusObj)[0];
                  const statusValue = statusObj[statusKey];
                  return (
                    <option key={index} value={statusValue}>
                      {statusValue}
                    </option>
                  );
                })
              ) : (
                <option>Loading...</option>
              )}
            </select>
          </td>
          <td style={{ whiteSpace: 'nowrap' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Link to={`/chargers/edit/${charger?._id}`} state={{ ChargerEditData: charger }}>
              <i className="fa fa-edit"  title="Edit Charger"></i>
            </Link>
            &nbsp;&nbsp;&nbsp;
            <Link to={`/chargers/view/${charger?._id}`} >
              <i className="fa fa-eye"  title="View Charger"></i>
            </Link>
          </td>
        </tr>
      ))
    )}
  </tbody>
</table>

                    </div>

                    <div className="pagination-container mt-4">
                      <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                        forcePage={page - 1} 
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chargers;
